"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays the appropriate button to allow the user to accept online/disallow payment.
// for a waiting list entry.
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Days Allowed")));
class OfferHistory extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getInvitationsToPay", () => {
      if (!this.props.entry.invitationsToPay.length) return null;
      return this.props.entry.invitationsToPay.map(invitation => {
        if (!invitation.dataString.length) return invitation;
        const data = JSON.parse(invitation.dataString);
        return {
          id: invitation.id,
          daysAllowed: data.daysAllowed,
          from: data.from
        };
      }).filter(invite => invite.daysAllowed !== undefined);
    });
  }
  render() {
    const invitations = this._getInvitationsToPay();
    return /*#__PURE__*/_react.default.createElement("div", null, !invitations || !invitations.length ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, this.props.entry.bibName, " has previously been offered a place and given the opportunity to pay:"), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-6 col-xs-8 offset-sm-3 offset-xs-2"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, invitations.map(invite => /*#__PURE__*/_react.default.createElement("tr", {
      key: invite.id
    }, /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(invite.from, 'ddd D MMM')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, invite.daysAllowed))))))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(OfferHistory, "partialQueries", {
  Entry: {
    bibName: true,
    invitationsToPay: {
      id: true,
      dataString: true
    }
  }
});
var _default = exports.default = OfferHistory;